/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S6_HeadingInputs */

const tr_iade_iptal_s6_heading = /** @type {(inputs: Iade_Iptal_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Deneme Süresi (Free Trial) İptali`)
};

const en_iade_iptal_s6_heading = /** @type {(inputs: Iade_Iptal_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Cancellation during the Trial Period (Free Trial)`)
};

const de_iade_iptal_s6_heading = /** @type {(inputs: Iade_Iptal_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Kündigung während der Testphase (Free Trial)`)
};

const ru_iade_iptal_s6_heading = /** @type {(inputs: Iade_Iptal_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Отмена в течение пробного периода (Free Trial)`)
};

/**
* | output |
* | --- |
* | "6. Cancellation during the Trial Period (Free Trial)" |
*
* @param {Iade_Iptal_S6_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s6_heading = /** @type {((inputs?: Iade_Iptal_S6_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S6_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s6_heading(inputs)
	if (locale === "de") return de_iade_iptal_s6_heading(inputs)
	if (locale === "ru") return ru_iade_iptal_s6_heading(inputs)
	return tr_iade_iptal_s6_heading(inputs)
});